import { render, staticRenderFns } from "./NewForgotPassword.vue?vue&type=template&id=8c678e66&scoped=true"
import script from "./NewForgotPassword.vue?vue&type=script&lang=js"
export * from "./NewForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./NewForgotPassword.vue?vue&type=style&index=0&id=8c678e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c678e66",
  null
  
)

export default component.exports